export enum ActionTypes {
  OPEN_MODAL_USER_INFO = 'OPEN_MODAL_USER_INFO',
  CLOSE_MODAL_USER_INFO = 'CLOSE_MODAL_USER_INFO',

  OPEN_MODAL_ADDING_QUESTION = 'OPEN_MODAL_ADDING_QUESTION',
  CLOSE_MODAL_ADDING_QUESTION = 'CLOSE_MODAL_ADDING_QUESTION',

  OPEN_MODAL_ADDING_QUESTION_USER_EVALUATED = 'OPEN_MODAL_ADDING_QUESTION_USER_EVALUATED',
  CLOSE_MODAL_ADDING_QUESTION_USER_EVALUATED = 'CLOSE_MODAL_ADDING_QUESTION_USER_EVALUATED',

  OPEN_MODAL_ADDING_SECTION = 'OPEN_MODAL_ADDING_SECTION',
  CLOSE_MODAL_ADDING_SECTION = 'CLOSE_MODAL_ADDING_SECTION',

  OPEN_MODAL_CONFIRM = 'OPEN_MODAL_CONFIRM',
  CLOSE_MODAL_CONFIRM = 'CLOSE_MODAL_CONFIRM',

  OPEN_MODAL_LOCK_SURVEY = 'OPEN_MODAL_LOCK_SURVEY',
  CLOSE_MODAL_LOCK_SURVEY = 'CLOSE_MODAL_LOCK_SURVEY',

  OPEN_MODAL_PUBLISH_SURVEY = 'OPEN_MODAL_PUBLISH_SURVEY',
  CLOSE_MODAL_PUBLISH_SURVEY = 'CLOSE_MODAL_PUBLISH_SURVEY',

  OPEN_MODAL_DRAFT_SURVEY = 'OPEN_MODAL_DRAFT_SURVEY',
  CLOSE_MODAL_DRAFT_SURVEY = 'CLOSE_MODAL_DRAFT_SURVEY',

  OPEN_MODAL_UPLOAD_SURVEY = 'OPEN_MODAL_UPLOAD_SURVEY',
  CLOSE_MODAL_UPLOAD_SURVEY = 'CLOSE_MODAL_UPLOAD_SURVEY',

  OPEN_MODAL_CONFIRM_SHOW_SURVEY_RESULTS = 'OPEN_MODAL_CONFIRM_SHOW_SURVEY_RESULTS',
  CLOSE_MODAL_CONFIRM_SHOW_SURVEY_RESULTS = 'CLOSE_MODAL_CONFIRM_SHOW_SURVEY_RESULTS',
  OPEN_MODAL_CONFIRM_DELETE_QUESTION_USED_IN_SURVEY = 'OPEN_MODAL_CONFIRM_DELETE_QUESTION_USED_IN_SURVEY',
  CLOSE_MODAL_CONFIRM_DELETE_QUESTION_USED_IN_SURVEY = 'CLOSE_MODAL_CONFIRM_DELETE_QUESTION_USED_IN_SURVEY',

  OPEN_MODAL_CONFIRM_EXIT_EDIT_SURVEY = 'OPEN_MODAL_CONFIRM_EXIT_EDIT_SURVEY',
  CLOSE_MODAL_CONFIRM_EXIT_EDIT_SURVEY = 'CLOSE_MODAL_CONFIRM_EXIT_EDIT_SURVEY',

  EDIT_EMPLOYEE_INFO = 'EDIT_EMPLOYEE_INFO',
  SWITCH_INFO_PERSON_DISPLAYED = 'SWITCH_INFO_PERSON_DISPLAYED',

  ADD_QUESTION_INTO_QUESTIONLIST = 'ADD_QUESTION_INTO_QUESTIONLIST',

  ADD_GROUP_QUESTIONS = 'ADD_GROUP_QUESTIONS',

  ADD_QUESTION_INTO_FIRST_QUESTIONLIST = 'ADD_QUESTION_INTO_FIRST_QUESTIONLIST',

  MOVE_QUESTION_IN_GROUP = 'MOVE_UP_QUESTION_IN_GROUP',

  MOVE_SECTION_IN_GROUP = 'MOVE_SECTION_IN_GROUP',

  REMOVE_QUESTION_IN_GROUP = 'REMOVE_QUESTION_IN_GROUP',

  REMOVE_SECTION_IN_GROUP = 'REMOVE_SECTION_IN_GROUP',

  SET_SELECT_QUESTION = 'SET_SELECT_QUESTION',
  SET_SELECT_SECTION = 'SET_SELECT_SECTION',
  EDIT_SELECT_QUESTION_IN_GROUP = 'EDIT_SELECT_QUESTION_IN_GROUP',

  SAVE_ALL_TABS_BEGIN = 'SAVE_ALL_TABS_BEGIN',
  SAVE_ALL_TABS_END = 'SAVE_ALL_TABS_END',

  SET_SURVEY_TAB_1_INFORMATION = 'SET_SURVEY_TAB_1_INFORMATION',
  SET_SURVEY_TAB_3_MEMBERSEARCH = 'SET_SURVEY_TAB_3_MEMBERSEARCH',
  SET_SURVEY_TAB_3_MEMBER_GROUP_FILTER = 'SET_SURVEY_TAB_3_MEMBER_GROUP_FILTER',
  SET_SURVEY_TAB_3_MEMBER_OBJECTGROUP = 'SET_SURVEY_TAB_3_MEMBER_OBJECTGROUP',
  SET_SURVEY_TAB_3_MEMBERLIST = 'SET_SURVEY_TAB_3_MEMBERLIST',
  SET_SURVEY_TAB_3_MEMBERLIST_ALL = 'SET_SURVEY_TAB_3_MEMBERLIST_ALL',
  SET_SURVEY_TAB_3_MEMBERLIST_360 = 'SET_SURVEY_TAB_3_MEMBERLIST_360',
  SET_SURVEY_TAB_3_MEMBERLIST_ALL_360 = 'SET_SURVEY_TAB_3_MEMBERLIST_ALL_360',
  SET_SURVEY_TAB_3_MEMBERLIST_SELECTED = 'SET_SURVEY_TAB_3_MEMBERLIST_SELECTED',
  SET_SURVEY_TAB_3_MEMBERLIST_CHOSEN = 'SET_SURVEY_TAB_3_MEMBERLIST_CHOSEN',

  HANDLE_CHANGE_TABS = 'HANDLE_CHANGE_TABS',

  INIT_SURVEY = 'INIT_SURVEY',

  SET_LOADING = 'SET_LOADING',
  SET_DISABLED_SURVEY_EDIT = 'SET_DISABLED_SURVEY_EDIT',

  UPDATE_QUESTION_EVALUATED_IN_GROUP = 'UPDATE_QUESTION_EVALUATED_IN_GROUP',
  SET_IS_VIEW_SURVEY = 'SET_IS_VIEW_SURVEY',
  SET_SKIP_MODAL_CONFIRM = 'SET_SKIP_MODAL_CONFIRM',
  SET_SAVE_TAB = 'SET_SAVE_TAB',
  SET_USER_CHANGE_MODAL_ADD_QUESTION = 'SET_USER_CHANGE_MODAL_ADD_QUESTION',
  SET_LIST_OF_BONUS_CODE_TAB_1_INFORMATION = 'SET_LIST_OF_BONUS_CODE_TAB_1_INFORMATION',
  SET_INFO_PEOPLE = 'SET_INFO_PEOPLE',

  SET_DISABLED_SURVEY_360 = 'SET_DISABLED_SURVEY_360',

  SET_SURVEY_TYPE_FORM = 'SET_SURVEY_TYPE_FORM',

  SET_QUESTION_ID_ARR_COPY = 'SET_QUESTION_ID_ARR_COPY',

  SET_SURVEY_DATA_SAVE = 'SET_SURVEY_DATA_SAVE',

  SET_EVALUATED_QUESTION_EXIST = 'SET_EVALUATED_QUESTION_EXIST',

  SET_IS_COPY_SURVEY = 'SET_IS_COPY_SURVEY',

  SET_QUESTION_ORDER = 'SET_QUESTION_ORDER',

  SET_MEMBER_GROUP_INFO = 'SET_MEMBER_GROUP_INFO',
  SET_LOADING_MEMBER_GROUP_INFO = 'SET_LOADING_MEMBER_GROUP_INFO',

  SET_TYPE_ACTION_CHANGE_LIST_MEMBER_GROUP = 'SET_TYPE_ACTION_CHANGE_LIST_MEMBER_GROUP',

  SET_CURRENT_VALUE_INFORMATION_TAB = 'SET_CURRENT_VALUE_INFORMATION_TAB',

  OPEN_MODAL_UPLOAD_EVALUATED_PEOPLE_360 = 'OPEN_MODAL_UPLOAD_EVALUATED_PEOPLE_360',
  CLOSE_MODAL_UPLOAD_EVALUATED_PEOPLE_360 = 'CLOSE_MODAL_UPLOAD_EVALUATED_PEOPLE_360',

  SET_DDL_REGION_MEMBER_GROUP_BACKUP = 'SET_DDL_REGION_MEMBER_GROUP_BACKUP',
  SET_DDL_UNIT_MEMBER_GROUP_BACKUP = 'SET_DDL_UNIT_MEMBER_GROUP_BACKUP',
  SET_DDL_DEPARTMENT_MEMBER_GROUP_BACKUP = 'SET_DDL_DEPARTMENT_MEMBER_GROUP_BACKUP',
  SET_DDL_DIVISION_MEMBER_GROUP_BACKUP = 'SET_DDL_DIVISION_MEMBER_GROUP_BACKUP',
  SET_DDL_RESTAURANT_MEMBER_GROUP_BACKUP = 'SET_DDL_RESTAURANT_MEMBER_GROUP_BACKUP',
  SET_DDL_LEVEL_MEMBER_GROUP_BACKUP = 'SET_DDL_LEVEL_MEMBER_GROUP_BACKUP',
  SET_DDL_POSITION_MEMBER_GROUP_BACKUP = 'SET_DDL_POSITION_MEMBER_GROUP_BACKUP',
  SET_LIST_STAFF_360 = 'SET_LIST_STAFF_360',
  SET_FETCH_QUESTION_AFTER_UPLOAD_EXCEL = 'SET_FETCH_QUESTION_AFTER_UPLOAD_EXCEL',
  SET_PARAM_FILTERS_EVALUATED_QUESTION = 'SET_PARAM_FILTERS_EVALUATED_QUESTION',

  SET_IS_FIRST_LOAD_TAB = 'SET_IS_FIRST_LOAD_TAB',
  SET_IS_MEMBER_LIST_360_CHANGED = 'SET_IS_MEMBER_LIST_360_CHANGED',
}
